import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import Button from '../../components/Button/Button';
import { notification, Collapse } from 'antd';
//import { getSubjectContent, getSchools } from "../../services/learnService";
import Place from '../../assets/icons/Place';
import picture from '../../assets/images/instructor.svg';
import { tutors } from '../../dummyData';

const TakeTutorCourse = () => {
  const { Panel } = Collapse;

  const ids = useParams();
  const navigate = useNavigate();

  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [tutor, setTutor] = useState([]);
  const [videoUrl, setVideoUrl] = useState('');
  const [units, setUnits] = useState(0);
  const [lessons, setLessons] = useState(0);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    let currentVideo = localStorage.getItem('currentVideo');
    const getContent = async () => {
      setTutor(tutors[ids.schoolId - 1]);
      setContent(tutors[ids.schoolId - 1].subjects[ids.subjectId - 1]);
      setVideoUrl(currentVideo);
    };
    getContent();
    scrollToTop();
  }, []);

  const changeVideoUrl = (url) => {
    setLoading(true);
    setVideoUrl(url);
    setTimeout(() => {
      console.log('hey');
      setLoading(false);
    }, '200');
  };

  console.log(videoUrl);

  return (
    <>
      <Helmet>
        <title>PL by Edves | Learn</title>
      </Helmet>
      <DashboardHeader />
      <div className='takecourse'>
        <div className='takecourse__breadcrumbs'>
          <span>
            <svg
              width='18'
              height='12'
              viewBox='0 0 18 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                fill='#161410'
              />
            </svg>
          </span>
          <p>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/dashboard')}
            >
              {' '}
              Home
            </span>{' '}
            | {tutor?.first_name} | {content?.title} |{' '}
          </p>
          <span>
            <p style={{ color: '#161410' }}>Learn {content?.title}</p>
          </span>
        </div>
        <div className='takecourse__body'>
          <div className='takecourse__body__course-details'>
            {loading ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '447px',
                }}
              >
                <p>Loading...</p>
              </div>
            ) : (
              <div className='takecourse__body__course-details__section'>
                {content?.units ? (
                  content?.units[units]?.lessons[lessons]?.type ===
                  'picture' ? (
                    <>
                      <img
                        src={
                          content?.units[units]?.lessons[lessons]?.file_location
                        }
                        alt=''
                      />
                      {lessons > 0 && (
                        <button
                          className='takecourse__body__course-details__section__prev'
                          onClick={() => setLessons(lessons - 1)}
                        >
                          <svg
                            width='8'
                            height='12'
                            viewBox='0 0 8 12'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M6.00016 12L7.41016 10.59L2.83016 6L7.41016 1.41L6.00016 0L0.000156403 6L6.00016 12Z'
                              fill='#5A5955'
                            />
                          </svg>
                        </button>
                      )}
                      {lessons + 1 !==
                        content?.units[units]?.lessons?.length && (
                        <button
                          className='takecourse__body__course-details__section__next'
                          onClick={() => setLessons(lessons + 1)}
                        >
                          <svg
                            width='8'
                            height='12'
                            viewBox='0 0 8 12'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z'
                              fill='#5A5955'
                            />
                          </svg>
                        </button>
                      )}
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginTop: '-40px',
                          color: '#fff',
                        }}
                      >
                        {lessons + 1} / {content?.units[units]?.lessons?.length}
                      </p>
                    </>
                  ) : (
                    <video controls autoPlay>
                      <source src={videoUrl} type='video/mp4' />
                      Your browser does not support HTML video.
                    </video>
                  )
                ) : (
                  <div></div>
                )}
              </div>
            )}
            <div className='takecourse__body__course-details__action'>
              <div className='takecourse__body__course-details__action__left'>
                <div className='takecourse__body__course-details__action__left__icon'>
                  <svg
                    width='12'
                    height='8'
                    viewBox='0 0 12 8'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M8 1.33333V6.66667H1.33333V1.33333H8ZM8.66667 0H0.666667C0.3 0 0 0.3 0 0.666667V7.33333C0 7.7 0.3 8 0.666667 8H8.66667C9.03333 8 9.33333 7.7 9.33333 7.33333V5L12 7.66667V0.333333L9.33333 3V0.666667C9.33333 0.3 9.03333 0 8.66667 0Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='takecourse__body__course-details__action__left__text'>
                  <h3>Confused about anything?</h3>
                  <p>Book a one- on- one session with the tutor</p>
                </div>
              </div>
              <div className='takecourse__body__course-details__action__right'>
                <Button
                  text='Speak to tutor'
                  className='primary-btn'
                  onClick={() => {
                    console.log('hey');
                  }}
                />
              </div>
            </div>

            <div className='takecourse__body__about'>
              <h3>About this subject</h3>
              <p>{content?.description}</p>

              <p className='learn-about__more'>
                Show More
                <svg
                  width='8'
                  height='6'
                  viewBox='0 0 8 6'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8 1.66656L7.06 0.726563L4 3.7799L0.94 0.726563L0 1.66656L4 5.66656L8 1.66656Z'
                    fill='#FEA82F'
                  />
                </svg>
              </p>
            </div>

            <div className='takecourse__body__about'>
              <h3>What you’ll learn</h3>
              <div className='learn-about__what-you-will-learn'>
                {content?.features?.map((el) => (
                  <div
                    className='learn-about__flex-item'
                    key={Math.random(1000)}
                  >
                    <div className='learn-about__flex-item__circle'>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                          fill='#161410'
                        />
                      </svg>
                    </div>
                    <p>{el.description}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className='takecourse__body__help'>
              <h3>Need extra help?</h3>
              <div className='takecourse__body__help__flex'>
                <div className='takecourse__body__help__flex__logo'>
                  <img src={tutor?.avatar || picture} alt={tutor?.first_name} />
                </div>
                <div className='takecourse__body__help__flex__tutor'>
                  <h4>{tutor?.first_name || 'Nnenna Okore'} </h4>
                  <div>
                    <Place />

                    <p>{tutor.location}</p>
                  </div>
                  <Button
                    text='Speak to tutor'
                    className='primary-btn'
                    onClick={() => {
                      console.log('speak to tutor');
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='takecourse__body__subject-content'>
            <h3>Subject Content</h3>

            <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
              {content?.units?.map((el, id) => (
                <Panel
                  className='takecourse__body__subject-content__collapse-header'
                  header={
                    <div>
                      <div className='takecourse__body__subject-content__heading'>
                        {' '}
                        <span style={{ marginRight: '10px', color: '#5A5955' }}>
                          <h4> {el.sn}</h4>
                        </span>
                        <span>
                          <h4> {el.description}</h4>
                        </span>
                      </div>
                      <div className='takecourse__body__subject-content__subheading'>
                        <p>0/1 completed | 15 mins</p>
                      </div>
                    </div>
                  }
                  key={el.id}
                >
                  {el.lessons.map((item) => (
                    <div className='content__topics__sub'>
                      <div
                        style={{
                          display: 'flex',
                          gap: '17px',
                        }}
                      >
                        <div style={{ marginTop: '3px' }}>
                          <svg
                            width='14'
                            height='12'
                            viewBox='0 0 14 12'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M11.7768 0H1.79339C1.00898 0 0.367188 0.6 0.367188 1.33333V10.6667C0.367188 11.4 1.00898 12 1.79339 12H11.7768C12.5612 12 13.203 11.4 13.203 10.6667V1.33333C13.203 0.6 12.5612 0 11.7768 0ZM11.7768 10.6667H1.79339V1.33333H11.7768V10.6667ZM11.0566 4L10.0511 3.05333L5.35176 7.44667L3.51196 5.73333L2.49936 6.67333L5.35176 9.33333L11.0566 4Z'
                              fill='#FEA82F'
                            />
                          </svg>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            gap: '17px',
                            flexDirection: 'column',
                            gap: '8px',
                          }}
                          onClick={() => {
                            setUnits(id);
                            setLessons(0);
                            changeVideoUrl(item?.file_location);
                          }}
                        >
                          <p style={{ fontWeight: 700 }}>{item.description}</p>
                          <p
                            style={{
                              fontWeight: 300,
                              fontSize: '12px !important',
                            }}
                          >
                            {item.type === 'video' ? (
                              <svg
                                width='14'
                                height='14'
                                viewBox='0 0 14 14'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M5.66634 9.99992L9.66634 6.99992L5.66634 3.99992V9.99992ZM6.99967 0.333252C3.31967 0.333252 0.333008 3.31992 0.333008 6.99992C0.333008 10.6799 3.31967 13.6666 6.99967 13.6666C10.6797 13.6666 13.6663 10.6799 13.6663 6.99992C13.6663 3.31992 10.6797 0.333252 6.99967 0.333252ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93992 1.66634 6.99992C1.66634 4.05992 4.05967 1.66659 6.99967 1.66659C9.93967 1.66659 12.333 4.05992 12.333 6.99992C12.333 9.93992 9.93967 12.3333 6.99967 12.3333Z'
                                  fill='#161410'
                                />
                              </svg>
                            ) : (
                              <svg
                                width='12'
                                height='12'
                                viewBox='0 0 12 12'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.44667 1.33333L10.6667 4.55333V10.6667H1.33333V1.33333H7.44667ZM7.44667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V4.55333C12 4.2 11.86 3.86 11.6067 3.61333L8.38667 0.393333C8.14 0.14 7.8 0 7.44667 0ZM2.66667 8H9.33333V9.33333H2.66667V8ZM2.66667 5.33333H9.33333V6.66667H2.66667V5.33333ZM2.66667 2.66667H7.33333V4H2.66667V2.66667Z'
                                  fill='#161410'
                                />
                              </svg>
                            )}{' '}
                            {item.duration}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default TakeTutorCourse;
